import { z } from 'zod';

/**
 * `GET /api/tasks/:taskId/deadline-audience` — how many people a Deadline
 * change on this task notifies: author, assignee, respondent, collaborators
 * and watchers, minus me, each counted once, and only those who can read the
 * task (P8).  The server answers with the SAME recipient set the
 * `task.due_changed` fan-out uses, so the Calendar's "notifies N people"
 * can't drift from who is actually told.  0 on a Personal task.
 */
export const DeadlineAudienceSchema = z.object({
  count: z.number().int().nonnegative(),
});
export type DeadlineAudience = z.infer<typeof DeadlineAudienceSchema>;
